.reauthModal {
  pointer-events: auto;
}

.reauthModalIframe {
  pointer-events: auto;
}
